import { render } from "./helpcenter_search.vue?vue&type=template&id=50e5e948&scoped=true"
import script from "./helpcenter_search.vue?vue&type=script&lang=js"
export * from "./helpcenter_search.vue?vue&type=script&lang=js"

import "./helpcenter_search.vue?vue&type=style&index=0&id=50e5e948&lang=scss&scoped=true"
import "./helpcenter_search.vue?vue&type=style&index=1&id=50e5e948&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e5e948"]])

export default __exports__